function displayTab(container, target) {
    const button = container.querySelector(`[action-display-tab="${target}"]`);
    const tab    = container.querySelector(`[data-tab="${target}"]`);
    const pill   = container.querySelector('.tabbed_inner .pill');

    if (!button || !tab || !pill) return;


    container.querySelectorAll('.tab_button').forEach(btn =>
        btn.classList.remove('active')
    );
    button.classList.add('active');


    requestAnimationFrame(() => {
        const buttonRect    = button.getBoundingClientRect();
        const containerRect = button.closest('.tabbed_inner').getBoundingClientRect();

        const offsetLeft = buttonRect.left - containerRect.left;
        const width      = buttonRect.width;

        pill.style.transform = `translateX(${offsetLeft}px)`;
        pill.style.width     = `${width}px`;
    });


    container.querySelectorAll('[data-tab]').forEach(el =>
        el.classList.remove('open')
    );
    tab.classList.add('open');
}

window.addEventListener('load', () => {
    document.querySelectorAll('.tabbed_container').forEach(container => {
        const activeButton =
            container.querySelector('.tab_button.active') ||
            container.querySelector('.tab_button');

        if (activeButton) {
            const tabId = activeButton.getAttribute('action-display-tab');
            displayTab(container, tabId);
        }
    });
});

document.addEventListener('click', function (event) {
    const target = event.target.closest('[action-display-tab]');
    if (!target) return;

    const container = target.closest('.tabbed_container');
    if (!container) return;

    event.preventDefault();
    const tabId = target.getAttribute('action-display-tab');
    displayTab(container, tabId);
});
